import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getMerchantCurrencySymbol } from "../../../../../helpers";
import {
  menuInitialValue,
  getEditMenuItem,
  getMenuItemModifiers,
} from "../../../../../Redux/actions";
import StandardModifiers from "./StandardModifiers";
import BundledModifiers from "./BundledModifiers";

const Modifiers = (props) => {
  const { id } = props;
  const history = useHistory();
  const dispatch = useDispatch();

  const user_details = useSelector((state) => state.authReducer.user_details);
  const merchantCurrency = getMerchantCurrencySymbol(user_details);
  const { item_modifiers_details } = useSelector((state) => state.menuReducer);

  useEffect(() => {
    dispatch(getMenuItemModifiers(`/${id}`));
    return () => {
      dispatch(menuInitialValue());
    };
  }, []);

  return (
    <>
      {console.log(
        "astasdasdsad",
        item_modifiers_details?.menu_item?.menu_item_type
      )}
      {item_modifiers_details?.menu_item?.menu_item_type == "standard" ? (
        <StandardModifiers
          id={id}
          item_modifiers_details={item_modifiers_details}
        />
      ) : (
        <BundledModifiers
          id={id}
          item_modifiers_details={item_modifiers_details}
        />
      )}
    </>
  );
};

export default Modifiers;
